import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dba80a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex min-w-0 flex-1 items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_icon_button = _resolveComponent("icon-button")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "in-out"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["fixed left-2/4 transform -translate-x-2/4 top-8 z-10 shadow-sm flex items-center border-2 border-solid rounded w-96 h-11 px-1", [_ctx.containerType]])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_icon, { name: _ctx.iconName }, null, 8, ["name"]),
          _createElementVNode("p", {
            class: _normalizeClass(["ml-2 flex-1 font-bold whitespace-nowrap overflow-hidden overflow-ellipsis", [_ctx.color]])
          }, _toDisplayString(_ctx.notification.message), 3)
        ]),
        _createVNode(_component_icon_button, {
          onOnClick: _ctx.onClose,
          name: "close",
          color: _ctx.color
        }, null, 8, ["onOnClick", "color"])
      ], 2)
    ], undefined, true),
    _: 1
  }))
}